import { HTTPError } from 'ky';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { useBasketTimer } from '~/shared/utils/storage';
import { clearBasket } from '../../operations/basket';

export default function useClearBasket() {
    const queryClient = useQueryClient();
    const { data: reference } = useBasketReference();
    const [, setTimer] = useBasketTimer();

    return useMutation<ShopTypes.BasketResponse, HTTPError | Error>(() => clearBasket(reference), {
        onSuccess: (data) => {
            queryClient.setQueryData(['basket', { reference: data.basketReference }], data);
            setTimer(data.updated.toString());
        },
    });
}
